/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GovernanceConfigurationBaseForOperations extends models.GovernanceConfigurationBase {
    getFixupPrototypeFunction() { return GovernanceConfigurationBaseForOperations.fixupPrototype; }

    static newInstance(model: Partial<GovernanceConfigurationBaseForOperations>): GovernanceConfigurationBaseForOperations {
        let obj = Object.assign(new GovernanceConfigurationBaseForOperations(), model);
        GovernanceConfigurationBaseForOperations.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GovernanceConfigurationBaseForOperations>): GovernanceConfigurationBaseForOperations {
        if (!model) return null;
        return GovernanceConfigurationBaseForOperations.newInstance(<GovernanceConfigurationBaseForOperations> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GovernanceConfigurationBaseForOperations) {
        if (!obj) return;

        models.GovernanceConfigurationBaseForOperations.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GovernanceConfigurationBaseForOperations): boolean {
        if (models.GovernanceConfigurationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, GovernanceConfigurationBaseForOperations.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.notifications) {
            models.ConfigurationForNotifications.fixupPrototype(this.notifications);
        }
    }

    /**
     * Notifications Settings For Operations
     */
    notifications: models.ConfigurationForNotifications;

}
